import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * FilterAccountView class extends JetView to create a filter form for accounts.
 */
export default class FilterAccountView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing input fields for filtering accounts
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            minWidth: 200,
                            label: _("<span class='icon-drivers-license-o'></span>ID"),
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder for ID input
                        },
                        {
                            view: 'text',
                            name: 'Name',
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'), // Placeholder for Name input
                        },
                        {
                            view: 'richselect',
                            name: 'State',
                            minWidth: 200,
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for State selection
                            options: [
                                { id: 'null', value: _('Todos') }, // Option for all states
                                { id: 'A', value: _('Activado') }, // Option for activated state
                                { id: 'I', value: _('Inactivado') }, // Option for deactivated state
                            ],
                        },
                    ],
                },
            ],
        };

        // Center left section (currently empty)
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the left filter inputs
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Buttons section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'button',
                            value: _('Añadir Cuenta'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            hidden: !devConfig.getPermAction('accountingAccountsAdd', 'Add'),
                            css: 'prm-accountingAccountsAdd', // Button for adding account
                            click: () => {
                                this.app.callEvent('addAccount:button', [{}]); // Event to add account
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            click: () => {
                                this.getRoot().clear(); // Clear the form inputs
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 250,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('Account:filter', [filterdata]); // Event to filter accounts
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for mobile view
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            view: 'button',
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultMobile',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('Account:filter', [filterdata]); // Event to filter accounts
                            },
                        },
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                accordion_section, // Main content of the form
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed to the init function.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('consultDesk').hide(); // Hide desktop consult button on small screens
            }
            if (screen.width >= 500) {
                $$('consultMobile').hide(); // Hide mobile consult button on larger screens
            }
        });
    }
}

// FILE DOCUMENTED
